import BaseHelper from './base-helper';
import API_MAP from '../configs/url-api';

class TariffsApi extends BaseHelper {
  getAllTariffs(params) {
    return this.request(API_MAP.PAID_SERVICES, {
      method: 'GET',
      auth: 'Bearer',
      perPage: 100,
      ...params,
    });
  }

  getTariffById(id) {
    return this.request(`${API_MAP.PAID_SERVICES}/${id}`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  addTariff(data) {
    return this.request(API_MAP.PAID_SERVICES, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  updateTariff(id, data) {
    return this.request(`${API_MAP.PAID_SERVICES}/${id}`, {
      method: 'PATCH',
      auth: 'Bearer',
      body: data,
    });
  }

  removeTariff(id) {
    return this.request(`${API_MAP.PAID_SERVICES}/${id}`, {
      method: 'DELETE',
      auth: 'Bearer',
    });
  }

  requestIndividualTariff(body) {
    return this.request(API_MAP.REQUEST_INDIVIDUAL_TARIFF, {
      method: 'POST',
      auth: 'Bearer',
      body,
    });
  }

  addPersonalTariff(data) {
    return this.request(API_MAP.PERSONAL_TARIFFS, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  getPersonalTariffs(params) {
    return this.request(API_MAP.PERSONAL_TARIFFS, {
      method: 'GET',
      auth: 'Bearer',
      perPage: 200,
      ...params,
    });
  }

  getPersonalTariffById(id) {
    return this.request(`${API_MAP.PERSONAL_TARIFFS}/${id}`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  updatePersonalTariff(id, data) {
    return this.request(`${API_MAP.PERSONAL_TARIFFS}/${id}`, {
      method: 'PATCH',
      auth: 'Bearer',
      body: data,
    });
  }

  removePersonalTariff(id) {
    return this.request(`${API_MAP.PERSONAL_TARIFFS}/${id}`, {
      method: 'DELETE',
      auth: 'Bearer',
    });
  }

  getAllIssuanceTariffs(params) {
    return this.request(`${API_MAP.PAID_SERVICES}/tariff-issuance`, {
      method: 'GET',
      auth: 'Bearer',
      perPage: 100,
      ...params,
    });
  }
}

export default new TariffsApi();
